import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let HumTemprouter = new Router({
  routes: [{
    path: '/',
    name: 'home',
    component: () => import('./views/Home.vue'),
    meta: {
      title: ''
    }
  },
  {
    path: '/product/:id?',
    name: 'product',
    component: () => import('./views/Product.vue')
  },
  {
    path: '/productdetails/:id?',
    name: 'productdetails',
    component: () => import('./views/ProductDetails.vue')
  },
  {
    path: '/sulutions',
    name: 'sulutions',
    component: () => import('./views/Solutions.vue')
  },
  {
    path: '/solutionsdetails/:id',
    name: 'solutionsdetails',
    component: () => import('./views/SolutionsDetails.vue')
  },
  {
    path: '/aboutus/',
    name: 'aboutus',
    component: () => import('./views/AboutUs.vue')
  },
  {
    path: '/news/',
    name: 'news',
    component: () => import('./views/News.vue')
  },
  {
    path: '/newsdetails/:index',
    name: 'newsdetails',
    component: () => import('./views/NewsDetails.vue')
  },

  ]
})

// 判断是否需要登录权限 以及是否登录
HumTemprouter.beforeEach((to, from, next) => {
  // 判断是否需要登录权限
  window.scrollTo(0, 0)
  if (to.matched.some(res => res.meta.requireAuth)) {
    // 判断是否登录
    if (sessionStorage.getItem('token')) {
      next()
    } else {
      // 没登录则跳转到登录界面
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    }
  } else {
    next()
  }
})

export default HumTemprouter